const SUFFIXES = [
  { v: 1e18, s: "Q" },
  { v: 1e15, s: "q" },
  { v: 1e12, s: "T" },
  { v: 1e9,  s: "B" },
  { v: 1e6,  s: "M" },
  { v: 1e3,  s: "k" },
];

export function fmt(n) {
  if (n == null || isNaN(n)) return "0";
  const abs = Math.abs(n);
  for (const { v, s } of SUFFIXES) {
    if (abs >= v) {
      const val = n / v;
      // Show one decimal only when it's non-zero and keeps us under 4 chars
      const str = val >= 100 ? Math.round(val).toString() : val.toFixed(1).replace(/\.0$/, "");
      return str + s;
    }
  }
  return Math.round(n).toString();
}
